export const config = {
  name: {
    required: true,
    value: '',
    hasDynamicRule: true
  },
  workflowId: {
    required: true,
    value: null
  },
  targetLanguage: {
    required: true,
    value: []
  }
};
